import React, {useMemo, useState} from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import dotsDropdown from '../../assets/icons/dotsDropdown.svg';
import edit from '../../assets/icons/edit.svg';
import tickBox from '../../assets/icons/tickBox.svg';
import avatar from '../../assets/images/avatar-2.png';
import layers from '../../assets/icons/layers.svg';
import switchBox from '../../assets/icons/switchBox.svg';
import arrowBox from '../../assets/icons/arrowBox.svg';
import Dropdown from '../UI/Dropdown';
import ReportModal from '../profile/ReportModal';
import RouteMap from '../../routes/RouteMap';
import {shortenAddress} from "../../utils/address";
import getFileURL from "../../utils/getFileURL";
import {toast} from "react-toastify";
import useModal from "../../hooks/useModal";
import ShareModal from "./ShareModal";
import {APP_NAME} from "../../constants";

function ProfileSummary({
  categories,
  activeCategory,
  onSetCategories,
  wrapperClassName,
  isUpvote,
    profile,
    editable = true
}) {
  const { t } = useTranslation();
  const [reportOpen, setReportOpen] = useState(false);
  const [open, toggleShareModal] = useModal()

  const shareURL = useMemo(() => {
    const origin = window.location.origin;

    return `${origin}/user/${profile?._id}`
  }, [profile])

  const dropdownItems = [
    { key: 1, title: t('profile.summary.report.title'), onClick: () => setReportOpen(true) },
  ];

  const DotsDropdown = ({ wrapperClass, menuItemsClass }) => (
    <div className={wrapperClass}>
      <Dropdown
        title={<img src={dotsDropdown} alt="dots dropdown" />}
        items={dropdownItems}
        displayChevronDown={false}
        menuButtonClass="justify-center"
        menuItemsClass={`top-9 w-36 rounded-40 shadow-lg ${menuItemsClass}`}
        menuItemClass="bg-white rounded-40 px-2 py-2.5 text-red text-center justify-center"
        width="w-8"
        onSelect={() => {}}
      />
    </div>
  );

  const UpvoteContent = ({ wrapperClass }) => (
    <div className={wrapperClass}>
      <div className="flex items-center space-x-3">
        <img className="" src={arrowBox} alt="arrow box" />
        <div className="text-blue">{t('upvote.giveUpvote')}</div>
      </div>
    </div>
  );

  return (
    <div className={wrapperClassName}>
      <ReportModal open={reportOpen} onCloseModal={() => setReportOpen(false)} />
      <ShareModal
          open={open}
          onDismiss={toggleShareModal}
          type={"Profile"}
          link={shareURL}
          optParams={{
            title: editable ? `My Profile on ${APP_NAME}` : `Check ${profile.name || profile?.wallet} on ${APP_NAME}`,
            quote: editable ? `My Profile on ${APP_NAME}` : `Check ${profile.name || profile?.wallet} on ${APP_NAME}`,
            media: profile?.avatar || undefined
          }}
      />
      <div className="bg-white rounded-24 px-5 py-8 lightShadow h-full">
        <div className="flex items-start justify-between mx-auto">
          <DotsDropdown wrapperClass="sm:hidden" menuItemsClass="left-0" />
          <div className="flex flex-col sm:flex-row sm:space-x-4 items-center">
            <div className="relative">
              <img className="rounded-full w-17 h-17 sm:w-19 sm:h-19 object-cover" src={profile?.avatar ? getFileURL(profile?.avatar) : avatar} alt="avatar" />
              {profile?.isVerified && (
                  <img className="absolute bottom-0 right-0" src={tickBox} alt="tick box" />
              )}
            </div>
            <div className="text-18 font-semibold text-center mt-2">{profile?.name || shortenAddress(profile?.wallet)}</div>
          </div>
          <div className="flex">
            <DotsDropdown wrapperClass="hidden sm:block mr-2" menuItemsClass="right-4" />
            {editable && (
                <Link to={RouteMap.profile.edit}>
                  <img src={edit} alt="edit" />
                </Link>
            )}
          </div>
        </div>
        <p className="text-14 sm:text-16 text-blue text-center sm:text-left opacity-75 mt-2 sm:mt-4.5">
          {profile?.bio}
        </p>
        <div className="flex lg:flex-col xl:flex-row justify-center sm:justify-start lg:items-start xl:items-center mt-4 xl:mt-9">
          <div className="flex w-full sm:max-w-320">
            <div
              className="flex items-center space-x-2 linearGradient rounded-12
                            w-full px-2 h-12 mr-4"
            >
              <div className="text-12 sm:text-14 text-white flex-grow">
                {shortenAddress(profile?.wallet, 8)}
              </div>
              <CopyToClipboard text={profile?.wallet} onCopy={() => toast.success(t('profile.summary.copied'))} >
                <img className="cursor-pointer" src={layers} alt="layers" />
              </CopyToClipboard>
            </div>
              <div onClick={toggleShareModal} className={'cursor-pointer'}>
                <img className="w-12 h-12" src={switchBox} alt="switch box" />
              </div>
          </div>
          {isUpvote && (
            <UpvoteContent wrapperClass="hidden sm:block w-full ml-4 lg:ml-0 xl:ml-11 lg:mt-4 xl:mt-0" />
          )}
        </div>
        <div
          className="sm:hidden flex justify-between border border-solid border-lightGray2
                     text-blue rounded-12 p-0.5 mt-7"
        >
          {categories.map((i) => (
            <div
              key={i.key}
              className={
                i.key === activeCategory
                  ? 'bg-blue text-white px-2 xs:px-3 py-3 rounded-10'
                  : 'flex items-center px-3 py-3'
              }
              onClick={() => onSetCategories(i.key)}
            >
              {i.title}
            </div>
          ))}
        </div>
        {isUpvote && <UpvoteContent wrapperClass="block sm:hidden mt-7" />}
      </div>
    </div>
  );
}

ProfileSummary.defaultProps = {
  profile: {}
}

export default ProfileSummary;
